var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"btn-main",attrs:{"disabled":_vm.disabled,"rounded":"","large":"","light":_vm.disabled}},'v-btn',_vm.link,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }